import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M37.811 10.832c.126 2.088.189 4.798.189 8.136 0 7.169-.29 15.79-.87 25.866a2 2 0 0 1-3.411 1.299l-8.16-8.16c-.612-.611-.857-.777-1.18-.876a1.272 1.272 0 0 0-.757 0c-.324.099-.57.265-1.181.876l-8.163 8.163a2 2 0 0 1-3.41-1.296C10.288 35.027 10 26.436 10 19.065c0-3.38.06-6.117.183-8.217a7 7 0 0 1 6.363-6.566C18.648 4.094 21.132 4 24 4c2.865 0 5.347.094 7.448.282a7 7 0 0 1 6.363 6.55Z",
    fill: "currentColor"
  }));
};

var SvgBookmark = styled(SvgComponent).withConfig({
  displayName: "Bookmark__SvgBookmark",
  componentId: "sc-qf5qwm-0"
})(["", " ", ""], size, color);
export default SvgBookmark;